import { queryOptions, useQuery } from '@tanstack/vue-query'

type ContactSettings = {
  data?: Record<string, { value?: string | null } | undefined>
}

// Contact + social links from /public/settings/contacts (public, read-only).
export const contactSettingsQuery = queryOptions({
  queryKey: ['settings', 'contacts'],
  retry: 0,
  staleTime: 1000 * 60 * 30,
  queryFn: async ({ signal }: { signal?: AbortSignal }) => {
    const { get } = useApi()
    return await get<ContactSettings>('/public/settings/contacts', undefined, { signal })
  },
  select: (res) => ({
    www: res?.data?.contact_www_url?.value || '',
    email: res?.data?.contact_email?.value || '',
    phone: res?.data?.contact_phone?.value || '',
    facebook: res?.data?.social_facebook?.value || '',
    instagram: res?.data?.social_instagram?.value || '',
    twitter: res?.data?.social_twitter?.value || '',
    youtube: res?.data?.social_youtube?.value || '',
    pinterest: res?.data?.social_pinterest?.value || '',
    tiktok: res?.data?.social_tiktok?.value || '',
    linkedin: res?.data?.social_linkedin?.value || '',
  }),
})

export function useContactSettings() {
  return useQuery(contactSettingsQuery)
}
